import * as Yup from "yup";

export const schemaChangePlan = Yup.object().shape({
  idSelected: Yup.string().required("You need to select a plan"),
});
